<template>
  <div class="baseLayout">
    <div class="headerContent">
      <div class="logo s_flex_ali">
        <img class="brand_logo" :src='info.picdomain+"/"+info.overView.brand_mark' alt="" v-if="info.overView.brand_mark" />
        <img class="brand_logo" :src="Logo" alt="" v-else/>
      </div>
      <div>
        <headerMenu :info="info" :loginOut='loginOut' :menu="menu"></headerMenu>
      </div>
    </div>
    <div class="layoutBody">
      <app-aside :menuToggle='menuToggle' :childrens='childrens' :info="info"></app-aside>
      <div class="layoutContent">
        <div class="layoutContentBox">
          <div class="breadcrumbStyle" v-if="key!='/index'">
            <header-breadcrumb :arr='breadCrumb'></header-breadcrumb>
          </div>
          <div class="view">
            <router-view />
            <app-footer></app-footer>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>
<style lang="less">
  @import "../style/layout.less";
</style>
<script>
  import { mapState } from "vuex";
  import AppAside from "./AppAside";
  import headerMenu from "./headerMenu";
  import AppFooter from './AppFooter';
  import { sendLogout } from "@/api/login";
  import { iscode } from "@/utils/app";
  import HeaderBreadcrumb from "./HeaderBreadcrumb";
  import store from '@/store'
  import Logo from '../assets/images/sigin_logo.png';
  //返回除了首页之外的面包屑
  const getBreadCrumb = (pathname, menuTree, crumb) => {
    // 首页返回false
    if (pathname === "/index") return false;
    // 递归遍历远端导航菜单tree
    for (let i = 0; i < menuTree.length; i++) {
      // 符合则添加到面包屑中
      // var url=/:id
      if (menuTree[i].url === pathname) {
        crumb.unshift(menuTree[i].title)
        return true;
      } else if (menuTree[i].url.indexOf('/:id') != -1 && pathname.indexOf(menuTree[i].url.replace('/:id', '')) != -1) {
        crumb.unshift(menuTree[i].title)
        return true;
      } else {
        // 不符合如果有子集继续查找
        if (menuTree[i] && menuTree[i].children && menuTree[i].children.length > 0) {
          let state = getBreadCrumb(pathname, menuTree[i].children, crumb);
          if (state) {
            crumb.unshift(menuTree[i].title)
            return true;
          }
        }
      }
    }
    return false;
  };
  export default {
    name: "DefaultLayout",
    components: {
      AppAside,
      headerMenu,
      AppFooter,
      HeaderBreadcrumb
    },
    computed: {
      key() {
        return this.$route.path;
      },
      ...mapState({
        menu: (state) => state.user.info.menu,
        childrens: (state) => state.user.asideMenu,
        menuToggle: (state) => state.app.menuToggle,
      }),
      breadCrumb() {
        let breadCrumb = [];
        getBreadCrumb(this.$route.path, this.menu, breadCrumb);
        return breadCrumb;
      },
    },
    data() {
      return {
        info: store.state.user.info,
        Logo
      };
    },
    mounted() { },
    methods: {
      async loginOut() {
        try {
          let res = await sendLogout().then(res => res.data);
          if (iscode(res)) {
            localStorage.removeItem("token")
            this.$router.push("/login");
            store.commit("user/SET_ASIDE_MENU", []);
          }
        } catch (e) {
          localStorage.removeItem("token")
          this.$router.push("/login");
          store.commit("user/SET_ASIDE_MENU", []);
        }
      },
    }
  };
</script>
<style lang="less">
  .breadcrumbStyle {
    background-color: #fff;
  }
  
</style>